/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsPublishPlugins } from "../funcs/pluginsPublishPlugins.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { PublishPluginsResult } from "../models/components/publishpluginsresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  PublishPluginsRequest,
  PublishPluginsSecurity,
} from "../models/operations/publishplugins.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type PublishPluginsMutationVariables = {
  request: PublishPluginsRequest;
  security?: PublishPluginsSecurity | undefined;
  options?: RequestOptions;
};

export type PublishPluginsMutationData = PublishPluginsResult;

export type PublishPluginsMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * publishPlugins plugins
 *
 * @remarks
 * Generate and publish all plugin packages to a GitHub repository.
 */
export function usePublishPluginsMutation(
  options?: MutationHookOptions<
    PublishPluginsMutationData,
    PublishPluginsMutationError,
    PublishPluginsMutationVariables
  >,
): UseMutationResult<
  PublishPluginsMutationData,
  PublishPluginsMutationError,
  PublishPluginsMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildPublishPluginsMutation(client, options),
    ...options,
  });
}

export function mutationKeyPublishPlugins(): MutationKey {
  return ["@gram/client", "plugins", "publishPlugins"];
}

export function buildPublishPluginsMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: PublishPluginsMutationVariables,
  ) => Promise<PublishPluginsMutationData>;
} {
  return {
    mutationKey: mutationKeyPublishPlugins(),
    mutationFn: function publishPluginsMutationFn({
      request,
      security,
      options,
    }): Promise<PublishPluginsMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(pluginsPublishPlugins(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
